import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { HttpService } from 'src/app/service/http/http.service';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';

import { EncryptionService } from 'src/app/service/encryption/encryption.service';

import { ToastrService } from 'ngx-toastr';
import { calculateFiscalYear, formatText, formatYearRanges } from 'src/app/shared/commen-function-file';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { EmployeeResignationComponent } from '../employee-resignation/employee-resignation.component';
import { ElcmTerminationComponent } from '../elcm-termination/elcm-termination.component';
import { saveAs } from 'file-saver';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { Observable } from 'rxjs';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { formatDate } from 'src/app/shared/commen-function-file';
import * as moment from 'moment';
import { ElcmGenericServiceService } from '../_elcm-services/elcm-generic-service.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { NoDueFormComponent } from '../no-due-form/no-due-form.component';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-elcm-exit',
  templateUrl: './elcm-exit.component.html',
  styleUrls: ['./elcm-exit.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ElcmExitComponent implements OnInit {
  @Input() getTabName: any;
  @Input() chechsetupStatus: any;
  selectedTypeTabName: any = 'myResigntion';
  selectedTypeTabIndex: any;

  buttonColorName: any;
  loggedInUserRole: any;
  adminAccessData: any = [];
  loggedInUserCompanyID: any;
  subModuleButtonColor: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any;
  setupNotCompleted: any;

  formatedataVariable = formatText;
  selectedYear: any;
  pmsYears: any;
  loggedInUserEmployeeCode: any;
  loggedInUserId: any;
  todayDate: Date = new Date();

  today = formatDate(new Date());

  constructor(private datePipe: DatePipe,

    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private encryptionService: EncryptionService,
    private cdRef: ChangeDetectorRef,
    private toastr: ToastrService,
    private elcmGenericService: ElcmGenericServiceService,
    public mobileResponsiveService: MobileResponsiveService
  ) {

  }

  ngOnInit() {

    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserEmployeeCode = sessionStorage.getItem('empCode');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
      if (this.loggedInUserRole == 'Admin') {
        this.elcmGenericService.getAllAccessMatrix(this.loggedInUserCompanyID).subscribe({
          next: (data: any) => this.adminAccessData = (data?.status && data?.data?.access[0]) ? data?.data?.access[0] : []
        });
      }
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getpmsyearlist();
    console.log(this.httpService.selectedOptionForExitPermission);

  }
  tabTypeChanged(event: MatTabChangeEvent) {

    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
    this.managetable();

    this.getExitFormData();
    this.searchTerm = "";
    this.searchTermTerminated = ""
    this.filterEmployeeTerminated();
  }

  DislaySelectedRecord(event: any) {
    this.listofFromData = this.currentlistofFromData.slice(0, event.value);
  }
  DislaySelectedRecordTermination(event: any) {
    this.terminationEmployeeList = this.currentterminationEmployeeList.slice(0, event.value);
  }


  fileName = 'ResignationData.xlsx';



  formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const day = ('0' + d.getDate()).slice(-2);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }

  exportToCSV() {

    const headers = this.OfferAndAppointmentTableHeader

      .filter((item: any) => item.label !== 'Edit') // exclude "Edit"
      .map((item: any) =>
        typeof item.label === 'string' ? item.label : item.label?.text || ''
      )
      .map((label: any) =>
        label === "Reason You Don't Want<br>the Manager To Know About" ||
          label === "Reason You Donâ€™t Want<br>the Manager To Know About" ||
          label === "Reason You Don’t Want<br>the Manager To Know About"
          ? "Reason You Don't Want the Manager To Know About"
          : label
      );

    console.log(headers);


    let rowMapper: any;

    if (
      this.checkAuthority === 'HOD_AND_HR' ||
      this.checkAuthority === 'MANAGER_AND_HR' ||
      this.checkAuthority === 'HOD_AND_MANAGER_AND_HR'
    ) {
      rowMapper = (item: any, index: number) => {


        const baseFields = [
          this.safeCSV(index + 1),
          this.safeCSV(item.empName),
          this.safeCSV(item.empDepartment),
          this.safeCSV(item.empBand),
          this.safeCSV(item.empGrade),
          this.safeCSV(item.empDesignation),
          this.safeCSV(item.resignDate),
          this.safeCSV(item.employmentType),
          this.safeCSV(item.noticePeriod),
          this.safeCSV(formatDate(item.lastWorkingDay)),
          this.safeCSV(item.resignReason),
          this.safeCSV(item.resignReasonInDetails),
          this.safeCSV(item.contactNo),
          this.safeCSV(item.personalMailId),

          ...(
            (this.selectedTypeTabName === 'myResigntion' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin')

              ? [this.safeCSV(item.secretReasonForHr)]
              : []
          ),




        ];

        const comments = [];

        if (this.checkAuthority === 'HOD_AND_HR') {
          comments.push(this.safeCSV(item.hodComment));

        } else if (this.checkAuthority === 'MANAGER_AND_HR') {
          comments.push(this.safeCSV(item.managerComment));

        } else if (this.checkAuthority === 'HOD_AND_MANAGER_AND_HR') {

          comments.push(this.safeCSV(item.managerComment));
          comments.push(this.safeCSV(item.hodComment));

        }
        console.log(this.selectedTypeTabName);

        const finalFields = [
          ...baseFields,
          ...comments,
          this.safeCSV(item.hrComment),
          ...((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || (this.loggedInUserRole == 'HOD' && this.selectedTypeTabName !== 'myResigntion')
            || (this.loggedInUserRole == 'Manager' && this.selectedTypeTabName !== 'myResigntion')) ? [this.safeCSV(item.regretType)] : []),
          this.safeCSV(item.approvalStatus),
          this.safeCSV(item.withdrawalAccepted ? '-' : '-'),
          this.safeCSV(item.withdrawalAccepted ? '-' : '-'),
          this.safeCSV(item.mailSend ? 'Sent' : 'Not Sent'),
          this.safeCSV(item.withdrawalReason),
        ];

        return finalFields;
      };
    }



    this.downloadCSVFile(
      (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') ? 'EmployeeResignationList.csv' : this.selectedTypeTabName == 'teamResigntion' ?
        'EmployeeTeamList.csv' : this.selectedTypeTabName == 'deptResigntion' ? 'EmployeeDeptList.csv' : 'EmployeeResignationList.csv',
      headers,
      this.listofFromData,
      (item: any, i: number) => rowMapper(item, i)
    );
  }


  exportTerminationToCSV() {
    const headers = this.terminationTableHeader
      .filter((item: any) => item.label !== 'Action') // exclude "Action"
      .map((item: any) =>
        typeof item.label === 'string' ? item.label : item.label?.text || ''
      );

    const rowMapper = (item: any, index: number) => {
      // Ensure valid date conversion
      // const dateOfTermination = this.datePipe.transform(new Date(item.dateOfTermination), 'MM-dd-yyyy');
      // const lastWorkingDay = this.datePipe.transform(new Date(item.lastWorkingDay), 'dd-MM-yyyy');
      const dateOfTermination = item.dateOfTermination;
      const lastWorkingDay = item.lastWorkingDay;
      const baseFields = [
        this.safeCSV(index + 1), // Sr. No
        this.safeCSV(item.empName), // Name
        this.safeCSV(item.empBand), // Band
        this.safeCSV(item.empGrade), // Grade
        this.safeCSV(item.empDepartment), // Department
        this.safeCSV(item.empDesignation), // Designation
        this.safeCSV(dateOfTermination), // Date Of Termination
        this.safeCSV(lastWorkingDay), // Last Working Day
        this.safeCSV(item.personalMailId),
        this.safeCSV(item.terminationReason), // Termination Reason
        this.safeCSV(item.withdrawalAccepted ? '-' : '-'),

        this.safeCSV(item.revolveStatus ? 'Revoked' : 'Active'), // Revoke Status
      ];
      // ✅ Add mail status field ONLY for HR roles
      if (this.loggedInUserRole === 'Super Admin' || this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
        baseFields.push(this.safeCSV(item.mailSend ? 'Sent' : 'Not Sent'));
      }

      const finalFields = [
        ...baseFields,
        ...(this.getTabName !== 'ExitReport' ? [''] : []), // Optional Action column
      ];

      return finalFields;
    };

    this.downloadCSVFile(
      'EmployeeTerminationList.csv',
      headers,
      this.terminationEmployeeList,
      rowMapper
    );
  }

  // Ensures CSV-safe values, wrapped in quotes
  safeCSV(value: any): string {
    const str = value !== undefined && value !== null ? String(value) : '';
    const escaped = str.replace(/"/g, '""');

    // Prevent Excel auto-formatting: force as text with tab or single quote
    if (/^\d{2}-\d{2}-\d{4}$/.test(escaped)) {
      return `"\t${escaped}"`; // tab prefix
      // return `"'\u200E${escaped}"`; // alternative: invisible character or single quote
    }

    return `"${escaped}"`;
  }

  downloadCSVFile(
    filename: string,
    headers: string[],
    data: any[],
    rowMapper: (item: any, index: number) => string[]
  ): void {
    if (!data || data.length === 0) return;

    const csvRows = [
      headers.map(h => `"${h}"`).join(','),
      ...data.map((item, index) => rowMapper(item, index).join(','))
    ];

    const csvData = csvRows.join('\n');
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }





  OfferAndAppointmentTableHeader: any = []
  checkAuthority: any;
  managetable() {
    this.OfferAndAppointmentTableHeader = [
      { label: "Sr. No", maxWidth: "180px" },
      { label: "Name", maxWidth: "180px" },
      { label: "Department ", maxWidth: "180px" },
      { label: "Band", maxWidth: "180px" },
      { label: "Grade", maxWidth: "180px" },
      { label: "Designation", maxWidth: "180px" },
      { label: "Resignation Date ", maxWidth: "180px" },
      { label: "Employment ", maxWidth: "180px" },
      { label: "Notice period", maxWidth: "180px" },
      { label: "LWD", maxWidth: "180px" },
      { label: "Exit Reason", maxWidth: "180px" },
      { label: this.breakAfterWord("Detail Exit Reason ", "The") },
      { label: this.breakAfterWord("Contact No.", "Mobile") },
      { label: "Personal Mail", maxWidth: "180px" },
      // <-- Remove "HR Comment On Resignation" from here
      { label: "Resignation Status", maxWidth: "180px" },
      { label: "Additional Question", maxWidth: "180px" },
      { label: "No Due Form", maxWidth: "180px" },
      { label: "Withdrawal Status", maxWidth: "180px" },
      // { label: "Edit", maxWidth: "180px" }
    ];

    const insertIndex = this.OfferAndAppointmentTableHeader.findIndex((item: any) => item.label === "Resignation Status");


    // Labels to insert
    const newLabels = [
      { label: this.breakAfterWord("Reason You Don't Want the Manager To Know About", "the") },
      { label: this.breakAfterWord("HOD Comment", "On") },
      { label: this.breakAfterWord("HR Comment", "On") },
    ];
    const newLabelsForManager = [
      { label: this.breakAfterWord("Reason You Don't Want the Manager To Know About", "the") },
      { label: this.breakAfterWord("Manager Comment", "On") },
      { label: this.breakAfterWord("HR Comment", "On") },
    ];
    const newLabelsForTeamAndHod = [

      // { label: this.breakAfterWord("Manager Comment On Resignation", "On") },
      { label: this.breakAfterWord("HOD Comment ", "On") },
      { label: this.breakAfterWord("HR Comment ", "On") },
      { label: "RegretType ", maxWidth: "180px" },
    ];

    const newLabelsForTeam = [

      { label: this.breakAfterWord("Manager Comment ", "On") },
      // { label: this.breakAfterWord("HOD Comment On Resignation", "On") },
      { label: this.breakAfterWord("HR Comment", "On") },
      { label: "RegretType ", maxWidth: "180px" },
    ];
    const newLabelsForHR_Manager = [
      { label: this.breakAfterWord("Reason You Don’t Want the Manager To Know About", "the") },
      { label: this.breakAfterWord("Manager Comment ", "On") },
      { label: this.breakAfterWord("HR Comment ", "On") },
      { label: "RegretType ", maxWidth: "180px" },
    ];

    const newLabelsForHR_HOD = [
      { label: this.breakAfterWord("Reason You Don’t Want the Manager To Know About", "the") },
      { label: this.breakAfterWord("HOD Comment ", "On") },
      { label: this.breakAfterWord("HR Comment ", "On") },
      { label: "RegretType ", maxWidth: "180px" },
    ];
    const newLabelsForHR_HOD_MANAGER = [
      { label: this.breakAfterWord("Reason You Don’t Want the Manager To Know About", "the") },
      { label: this.breakAfterWord("Manager Comment ", "On") },
      { label: this.breakAfterWord("HOD Comment ", "On") },
      { label: this.breakAfterWord("HR Comment ", "On") },
      { label: "RegretType ", maxWidth: "180px" },
    ];
    const newLabelsForHR_HOD_Manager = [
      { label: this.breakAfterWord("Manager Comment ", "On") },
      { label: this.breakAfterWord("HOD Comment ", "On") },
      { label: this.breakAfterWord("HR Comment ", "On") },
      { label: "RegretType ", maxWidth: "180px" },

    ];
    const newLabelsForHR_HOD_ManagermyResignation = [
      { label: this.breakAfterWord("Reason You Don’t Want the Manager To Know About", "the") },
      { label: this.breakAfterWord("Manager Comment ", "On") },
      { label: this.breakAfterWord("HOD Comment ", "On") },
      { label: this.breakAfterWord("HR Comment ", "On") },

    ];
    setTimeout(() => {

      this.checkAuthority = this.httpService.selectedOptionForExitPermission;
      const isAdminRole = ['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(this.loggedInUserRole);
      if (

        (this.checkAuthority == 'HOD_AND_HR') &&
        this.selectedTypeTabName === 'myResigntion' && !isAdminRole

      ) {
        console.log("inside my ");
        this.OfferAndAppointmentTableHeader.splice(insertIndex, 0, ...newLabels);
        if (this.getTabName !== 'ExitReport') {

          this.OfferAndAppointmentTableHeader.push({ label: "Edit", maxWidth: "180px" })
        }
      } else if (

        (this.checkAuthority == 'MANAGER_AND_HR') &&
        this.selectedTypeTabName === 'myResigntion' && !isAdminRole
      ) {
        console.log("inside my ");
        this.OfferAndAppointmentTableHeader.splice(insertIndex, 0, ...newLabelsForManager);
        // this.OfferAndAppointmentTableHeader.push({ label: "Edit", maxWidth: "180px" })
        if (this.getTabName !== 'ExitReport') {

          this.OfferAndAppointmentTableHeader.push({ label: "Edit", maxWidth: "180px" })
        }
      }

      else if (this.checkAuthority == 'HOD_AND_HR' &&
        (this.selectedTypeTabName === 'teamResigntion' || this.selectedTypeTabName == 'deptResigntion' && !isAdminRole)) {
        console.log("inside team");

        // this.OfferAndAppointmentTableHeader.push({ label: "RegretType ", maxWidth: "180px" })
        this.OfferAndAppointmentTableHeader.splice(insertIndex, 0, ...newLabelsForTeamAndHod);
      }
      else if (this.checkAuthority == 'MANAGER_AND_HR' &&
        (this.selectedTypeTabName === 'teamResigntion' && !isAdminRole)) {
        console.log("inside team");

        // this.OfferAndAppointmentTableHeader.push({ label: "RegretType ", maxWidth: "180px" })
        this.OfferAndAppointmentTableHeader.splice(insertIndex, 0, ...newLabelsForTeam);
      }
      else if (this.checkAuthority == 'HOD_AND_MANAGER_AND_HR' &&
        (!isAdminRole)) {
        if (this.selectedTypeTabName === 'myResigntion') {
          this.OfferAndAppointmentTableHeader.splice(insertIndex, 0, ...newLabelsForHR_HOD_ManagermyResignation);
          // this.OfferAndAppointmentTableHeader.push({ label: "Edit", maxWidth: "180px" })
          if (this.getTabName !== 'ExitReport') {

            this.OfferAndAppointmentTableHeader.push({ label: "Edit", maxWidth: "180px" })
          }
        } else {
          console.log("inside hr");

          this.OfferAndAppointmentTableHeader.splice(insertIndex, 0, ...newLabelsForHR_HOD_Manager);
        }

      }
      else if (isAdminRole) {
        console.log("inside HR");

        // this.OfferAndAppointmentTableHeader.push({ label: "RegretType ", maxWidth: "180px" })
        if ((this.checkAuthority == 'MANAGER_AND_HR')) {

          this.OfferAndAppointmentTableHeader.splice(insertIndex, 0, ...newLabelsForHR_Manager);
        } else if (this.checkAuthority == 'HOD_AND_HR') {
          this.OfferAndAppointmentTableHeader.splice(insertIndex, 0, ...newLabelsForHR_HOD);
        } else {
          this.OfferAndAppointmentTableHeader.splice(insertIndex, 0, ...newLabelsForHR_HOD_MANAGER);
        }
        // ✅ Always add "Relieving/Experience Letter" after "No Due Form"
        const noDueIndex = this.OfferAndAppointmentTableHeader.findIndex(
          (item: any) => item.label === "No Due Form"
        );
        if (noDueIndex !== -1) {
          this.OfferAndAppointmentTableHeader.splice(noDueIndex + 1, 0, {
            label: "Relieving/Experience Letter",
            maxWidth: "200px"
          });
        }

      }
    }, 100)


    // Insert before "Resignation Status"



  }


  breakAfterWord(label: string, word: string): string {
    return label.replace(` ${word} `, `<br>${word} `);
  }


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      // Additional function calls
      this.managetable();
      this.getExitFormData();
      this.getterminationFormData();
      this.initializeTableHeaderBasedOnTab();

    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');

    }
  }

  employeeResignation(event: any, type: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    // dialogConfig.height = '70%';
    // dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.width = window.innerWidth <= 576 ? '95%' : '80%';
    dialogConfig.panelClass = 'phi-mdc-dialog__container';  // Only set this class once
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      employeeData: event,
      type: type

    };

    const dialogRef = this.dialog.open(EmployeeResignationComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getExitFormData()

    });


  }


  viewLetter(employee: any, type: any) {
    if (type === 'send') {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        // height: '25%',
        // width: '30%',
        data: {
          msg: `Are you sure you want to send the relieving/experience letter to ${employee?.empName || 'this employee'}?`,
          btn2: 'Yes',
          btn1: 'No',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false,
        },
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.sendOrViewLetterresign(employee, type);
        }
      });
    } else {
      this.sendOrViewLetterresign(employee, type);
    }
  }

  sendOrViewLetterresign(employee: any, type: any) {
    // ✅ Show loader for this row
    if (type === 'send') {
      employee.isSendingLetter = true;
    } else {
      employee.isViewLetter = true;
    }

    const formData = {
      userId: employee?.userId,
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYear,
      verify: type,

    };

    this.httpService.callPostService(`${this.config.sendRelivingExpLetter}`, formData)
      .subscribe({
        next: (item: any) => {
          if (item.status) {
            if (type === 'send') {
              employee.isSendingLetter = false;

              this.toastr.success('Relieving/Experience letter sent successfully.')
              this.getExitFormData();
            } else {
              employee.isViewLetter = false;
              this.viewDocument(item.data);
              this.getExitFormData();
            }
          } else {
            employee.isSendingLetter = false;
            employee.isViewLetter = false;
            this.toastr.error(item.message)
            this.getExitFormData();
          }
        },
        error: (err: any) => {
          employee.isSendingLetter = false;
          employee.isViewLetter = false;
          this.toastr.error(err.message)
        }
      });
  }


  viewterminationLetter(employee: any, type: any) {
    if (type === 'send') {

      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        // height: '25%',
        // width: '30%',
        data: {
          msg: `Are you sure you want to send the termination letter to ${employee?.empName || 'this employee'}?`,
          btn2: 'Yes',
          btn1: 'No',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false,
        },
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.sendOrViewLetter(employee, type);
        }
      });
    } else {
      this.sendOrViewLetter(employee, type);
    }
  }


  sendOrViewLetter(employee: any, type: any) {
    if (type == 'send') employee.isSendingLetter = true;
    else employee.isViewLetter = true;

    const formData = {
      "userId": employee?.userId,
      "companyId": this.loggedInUserCompanyID,
      "year": this.selectedYear,
      "verify": type
    };

    this.httpService.callPostService(`${this.config.sendViewTerminationLetter}`, formData).subscribe({
      next: (item: any) => {
        if (item.status) {
          if (type == 'send') employee.isSendingLetter = false;

          else {
            employee.isViewLetter = false;
            this.viewDocument(item.data);
            this.getterminationFormData()
          }
          this.toastr.success(item.message)
        } else {
          employee.isViewLetter = false;
          this.toastr.error(item.message)
          this.getterminationFormData()
        }
        this.getterminationFormData()
      },
      error: (err) => {
        console.log(err);

        if (type === 'send') employee.isSendingLetter = false;
        else employee.isViewLetter = false;
        this.toastr.error(err.message)
      }
    });
  }
  viewDocument(fileUrl: string): void {

    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${this.loggedInUserCompanyID}/${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }

  }
  noDueForm(event: any) {
    console.log(event);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    // dialogConfig.height = '70%';
    // dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.width = window.innerWidth <= 576 ? '95%' : '80%';
    dialogConfig.panelClass = 'phi-mdc-dialog__container';  // Only set this class once
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      employeeData: event,
      year: this.selectedYear,
      companyId: this.loggedInUserCompanyID,
      report: this.getTabName == 'ExitReport' ? 'report' : 'elcm',


    };

    const dialogRef = this.dialog.open(NoDueFormComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if (this.selectedTypeTabName == 'termination') {
        this.getterminationFormData();
      } else {
        this.getExitFormData();
      }


    });


  }
  employeeTermintion(event: any, type: any) {
    console.log(event);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    // dialogConfig.height = '70%';
    dialogConfig.width = '70%';   // Try setting width to a smaller value
    // dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.width = window.innerWidth <= 576 ? '95%' : '80%';
    dialogConfig.panelClass = 'phi-mdc-dialog__container';  // Only set this class once
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      employeeData: event,
      type: type,
      terminatedEmployee: this.listOffTerminatedEmployee

    };

    const dialogRef = this.dialog.open(ElcmTerminationComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getterminationFormData()

    });


  }
  listofFromData: any = []
  currentlistofFromData: any = [];
  checkemployeeAcceptedRejected: any;
  getExitFormData() {
    this.httpService.callGetService(`${this.config.getExitAllForm}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`).subscribe((record: any) => {
      console.log(record);
      var userlist;

      setTimeout(() => {
        const isAdminRole = ['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(this.loggedInUserRole);

        // userlist = record.data.map((user: any) => {
        //   const match = this.terminationEmployeeList.find((emp: any) => emp.userId == user.userId && emp.revolveStatus == false);
        //   return {
        //     ...user,
        //     terminationFormId: match?.terminationFormId || null
        //   };
        // });

        userlist = record.data.map((user: any) => {
          const match = this.terminationEmployeeList.find(
            (emp: any) => emp.userId == user.userId && emp.revolveStatus == false
          );

          return {
            ...user,
            terminationFormId: match?.terminationFormId || null,
            // 🟢 Add moment-converted field (if date string is in 'DD-MM-YYYY')
            lastWorkingDay: user.lastWorkingDay ? moment(user.lastWorkingDay, 'DD-MM-YYYY') : null,
            isSendingLetter: false,
            isViewLetter: false
            // OR if ISO: moment(user.lastWorkingDay)
          };
        });
        console.log(userlist);


        if (this.loggedInUserRole == 'Admin') userlist = this.elcmGenericService.empFilterForAllEmployeeList(record?.data, this.adminAccessData?.employeeDetails, 'userId');


        if (

          (this.checkAuthority == 'HOD_AND_HR' || this.checkAuthority == 'MANAGER_AND_HR' || this.checkAuthority == 'HOD_AND_MANAGER_AND_HR') &&
          this.selectedTypeTabName === 'myResigntion' && !isAdminRole
        ) {
          console.log("inside if");


          let data = userlist.filter((elm: any) =>
            elm.userId?.toString().toLowerCase() === this.loggedInUserId?.toString().toLowerCase()
          );
          this.checkemployeeAcceptedRejected = data.filter((elm: any) => elm.approvalStatus == 'APPROVED');
          console.log(this.checkemployeeAcceptedRejected);

          this.listofFromData = data;
          this.currentlistofFromData = data


        } else if (

          this.checkAuthority == 'HOD_AND_HR' &&
          this.selectedTypeTabName === 'teamResigntion' && !isAdminRole
        ) {
          console.log("inside Manager");
          let data = userlist.filter((elm: any) => this.loggedInUserEmployeeCode === elm.managerCode && elm.userId != this.loggedInUserId);
          this.listofFromData = data;
          this.currentlistofFromData = data
        } else if (

          this.checkAuthority == 'HOD_AND_HR' &&
          this.selectedTypeTabName === 'deptResigntion' && !isAdminRole
        ) {
          console.log("inside hod");
          console.log(userlist);
          console.log(this.loggedInUserEmployeeCode);
          let data
          if (this.checkAuthority == 'HOD_AND_HR' && this.loggedInUserRole == 'HOD') {


            data = userlist.filter((elm: any) =>
              this.loggedInUserEmployeeCode === elm?.hodCode ||
              elm?.managerCode == elm?.hodCode &&
              elm?.userId != this.loggedInUserId
            );
          } else {
            console.log("99999999");

            data = userlist.filter((elm: any) =>
              this.loggedInUserEmployeeCode === elm?.hodCode &&
              elm?.managerCode !== elm?.hodCode &&
              elm?.userId != this.loggedInUserId
            );
          }
          this.listofFromData = data;
          console.log(this.listofFromData);

          this.currentlistofFromData = data

        } else if (

          this.checkAuthority == 'MANAGER_AND_HR' &&
          this.selectedTypeTabName === 'teamResigntion' && !isAdminRole
        ) {
          console.log("inside Manager");
          console.log(userlist);

          let data = userlist.filter((elm: any) => this.loggedInUserEmployeeCode == elm.managerCode && elm.userId != this.loggedInUserId);

          this.listofFromData = data;
          this.currentlistofFromData = data

        }
        else if (

          this.checkAuthority == 'HOD_AND_MANAGER_AND_HR' &&
          this.selectedTypeTabName === 'deptResigntion' && !isAdminRole
        ) {
          console.log("inside HOD_AND_MANAGER_AND_HR");
          console.log(userlist);
          console.log(this.loggedInUserId);
          let data = userlist.filter((elm: any) =>
            this.loggedInUserEmployeeCode === elm.hodCode &&
            elm.managerCode !== elm.hodCode &&
            elm.userId != this.loggedInUserId
          );
          this.listofFromData = data;
          this.currentlistofFromData = data

        } else if (

          this.checkAuthority == 'HOD_AND_MANAGER_AND_HR' &&
          this.selectedTypeTabName === 'teamResigntion' && !isAdminRole
        ) {
          console.log("inside HOD_AND_MANAGER_AND_HR");
          console.log(userlist);

          let data = userlist.filter((elm: any) => this.loggedInUserEmployeeCode == elm.managerCode && elm.userId != this.loggedInUserId);

          this.listofFromData = data;
          this.currentlistofFromData = data

        }

        else if (isAdminRole) {
          let data = userlist
          this.listofFromData = data;
          this.currentlistofFromData = data
        }

        else {

        }

      }, 100)
    })
  }

  searchTerm: any = ''; // Holds search input value
  filteredEmployees: any[] = []; // Holds filtered employee list

  filterEmployees() {
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      // Reset to the original full list
      this.listofFromData = [...this.currentlistofFromData];
      return;
    }
    const searchTextLower = this.searchTerm.toLowerCase().trim();

    let data = this.currentlistofFromData.filter((employee: any) =>
      Object.values(employee).some(value => {
        if (value === null || value === undefined) return false; // Skip null/undefined
        return value.toString().toLowerCase().includes(searchTextLower);
      })
    );


    this.listofFromData = data;


  }
  searchTermTerminated: any = ''
  filterEmployeeTerminated() {
    if (!this.searchTermTerminated || this.searchTermTerminated.trim() === '') {
      // Reset to the original full list
      this.terminationEmployeeList = [...this.currentterminationEmployeeList];
      return;
    }
    const searchTextLower = this.searchTermTerminated.toLowerCase().trim();

    let data = this.currentterminationEmployeeList.filter((employee: any) =>
      Object.values(employee).some(value => {
        if (value === null || value === undefined) return false; // Skip null/undefined
        return value.toString().toLowerCase().includes(searchTextLower);
      })
    );


    this.terminationEmployeeList = data;


  }
  onEdit(event: any, type: any) {
    this.employeeResignation(event, type);
  }

  withDraw(event: any, dept: any) {
    console.log(event);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    // dialogConfig.height = '50%';
    // dialogConfig.width = '50%';   // Try setting width to a smaller value
    dialogConfig.width = window.innerWidth <= 576 ? '95%' : '80%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'phi-mdc-dialog__container';  // Only set this class once
    dialogConfig.data = {
      employeeData: event,
      withDraw: "withDraw",
      depatement: dept
    };

    const dialogRef = this.dialog.open(EmployeeResignationComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getExitFormData()

    });
  }
  confirmAction(message: string): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      // height: '25%',
      // width: '30%',
      data: {
        msg: message,
        btn2: 'Yes',
        btn1: 'No',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    return dialogRef.afterClosed();
  }

  updateEmployeeData: any;

  updatedComment(item: any) {
    if (item.terminationFormId != null) {
      return;
    }


    this.updateEmployeeData = item;
    this.updateDataByHODAndManager();
  }

  updatedData(item: any) {
    if (item.terminationFormId != null) {
      return;
    }
    this.updateEmployeeData = item;
    console.log(this.updateEmployeeData.regretType);
    if (!(this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Admin' || this.loggedInUserRole === 'Super Admin' || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD')) {

      if (this.updateEmployeeData.regretType !== null) {


        // this.updateDataByHODAndManager();
        if (this.updateEmployeeData.regretType !== null) {
          this.confirmAction('Are you sure you want to proceed with the regret action?')
            .subscribe((confirmed: boolean) => {
              if (confirmed) {
                this.updateDataByHODAndManager();
              } else {
                item.regretType = null;
                this.getExitFormData();
                console.log('User cancelled regret confirmation.');
              }
            });
        }

      } else {

        this.updateDataByHODAndManager();
      }
    } else {
      if (this.updateEmployeeData.approvalStatus !== null) {
        this.confirmAction('Are you sure you want to' + " " + (this.updateEmployeeData.approvalStatus).toLowerCase())
          .subscribe((confirmed: boolean) => {
            if (confirmed) {
              this.updateDataByHODAndManager();
            } else {
              item.approvalStatus = null;
              this.getExitFormData();
              console.log('User cancelled regret confirmation.');
            }
          });
      }
    }
  }
  updateDataByHODAndManager() {
    let formData = {
      "resignationFormId": this.updateEmployeeData?.resignationFormId || null,
      "companyId": this.loggedInUserCompanyID,
      "userId": this.updateEmployeeData?.userId,
      "empName": this.updateEmployeeData?.empName,
      "empDepartment": this.updateEmployeeData?.empDepartment,
      "empGrade": this.updateEmployeeData?.empGrade,
      "empBand": this.updateEmployeeData?.empBand,
      "empDesignation": this.updateEmployeeData?.empDesignation,
      "employmentType": this.updateEmployeeData?.employmentType,
      "hodCode": this.updateEmployeeData.hodCode,
      "managerCode": this.updateEmployeeData.managerCode,
      "resignDate": this.updateEmployeeData?.resignDate,
      "noticePeriod": this.updateEmployeeData?.noticePeriod,
      "lastWorkingDay": formatDate(this.updateEmployeeData?.lastWorkingDay),
      "personalMailId": this.updateEmployeeData?.personalMailId,
      "resignReason": this.updateEmployeeData?.resignReason,
      "resignReasonInDetails": this.updateEmployeeData?.resignReasonInDetails,
      "contactNo": this.updateEmployeeData?.contactNo,
      "withdrawalReason": this.updateEmployeeData.withdrawalReason || null,
      "withdrawalAccepted": this.updateEmployeeData?.withdrawalAccepted,
      "secretReasonForHr": this.updateEmployeeData?.secretReasonForHr,
      "managerComment": this.updateEmployeeData?.managerComment || null,
      "hodComment": this.updateEmployeeData?.hodComment || null,
      "hrComment": this.updateEmployeeData?.hrComment || null,
      "regretType": this.updateEmployeeData?.regretType || null,
      "approvalStatus": this.updateEmployeeData?.approvalStatus,
      "userOfficialMail": this.updateEmployeeData?.userOfficialMail,
      "empCode": this.updateEmployeeData?.empCode,
      "hrMail": this.updateEmployeeData?.hrMail,
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "year": this.selectedYear,
    }

    this.httpService.callPostService(`${this.config.exitFormSave}`, formData).subscribe(
      (response: any) => {

        this.toastr.success(response.message);
        this.getExitFormData()
      },
      (error: any) => {

        const errorMsg = this.updateEmployeeData?.resignationFormId ? " Failed to updated" : "Failed to Added";
        this.toastr.error(errorMsg);
      }
    );
  }


  // -----------------------------------------------------------------------termination------------------------------------------------------------
  terminationTableHeader = [
    { label: "Sr. No", maxWidth: "180px" },
    { label: "Name", maxWidth: "180px" },
    { label: "Band", maxWidth: "180px" },
    { label: "Grade", maxWidth: "180px" },
    { label: "DepartMent", maxWidth: "180px" },
    { label: "Designation", maxWidth: "180px" },
    { label: "Date Of Termination", maxWidth: "180px" },
    { label: "LWD", maxWidth: "180px" },
    { label: "Personal Mail Id", maxWidth: "180px" },
    { label: 'Termination Reason', maxWidth: "180px" },
    { label: 'No Due Form', maxWidth: "180px" },
    { label: 'Revoke Status', maxWidth: "180px" },

  ]

  initializeTableHeaderBasedOnTab(): void {
    // ✅ Insert "Send Termination" before "Revoke Status" only for HR Admin
    if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      const revokeIndex = this.terminationTableHeader.findIndex(
        (col) => col.label === 'Revoke Status'
      );

      if (revokeIndex !== -1) {
        this.terminationTableHeader.splice(revokeIndex, 0, {
          label: 'Termination Letter',
          maxWidth: '180px',
        });
      }
    }

    if (this.getTabName !== 'ExitReport' && !['HOD', 'Manager', 'Employee', 'Finance'].includes(this.loggedInUserRole)) {

      this.terminationTableHeader.push({
        label: 'Action',
        maxWidth: '180px'
      });

    }
  }
  terminationEmployeeList: any = []
  currentterminationEmployeeList: any = []
  terminatedUserId: any;
  listOffTerminatedEmployee: any = []
  getterminationFormData() {
    this.httpService.callGetService(`${this.config.getTerminationAllForm}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`).subscribe((record: any) => {
      console.log("this.terminationEmployeeList");
      if (!record?.status && !(record?.data.length > 0)) return;

      if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
        console.log("hfgdfghkdfhgfd");

        this.terminationEmployeeList = record?.data.map((e: any) => {
          return {
            ...e,
            isSendingLetter: false,
            isViewLetter: false
          }
        });
        this.currentterminationEmployeeList = record?.data.map((e: any) => {
          return {
            ...e,
            isSendingLetter: false,
            isViewLetter: false
          }
        });
      } else if (this.loggedInUserRole == 'Eployee') {
        let data = record?.data.map((e: any) => {
          return {
            ...e,
            isSendingLetter: false,
            isViewLetter: false
          }
        });
        this.terminationEmployeeList = data?.filter((e: any) => e.empCode == this.loggedInUserEmpCode);
        this.currentterminationEmployeeList = data?.filter((e: any) => e.empCode == this.loggedInUserEmpCode);
      } else {
        let data = record?.data.map((e: any) => {
          return {
            ...e,
            isSendingLetter: false,
            isViewLetter: false
          }
        });
        this.terminationEmployeeList = data.filter((e: any) => e.managerCode == this.loggedInUserEmpCode || e.hodCode == this.loggedInUserEmpCode);
        this.currentterminationEmployeeList = data.filter((e: any) => e.managerCode == this.loggedInUserEmpCode || e.hodCode == this.loggedInUserEmpCode);
      }
      this.terminatedUserId = record?.data.filter((elm: any) => elm.userId == this.loggedInUserId && elm.revolveStatus == false);


      this.listOffTerminatedEmployee = record?.data.map((elm: any) => elm.userId);

      if (this.loggedInUserRole == 'Admin') {
        const terminatedEmpData = this.elcmGenericService.empFilterForAllEmployeeList(record?.data, this.adminAccessData?.employeeDetails, 'userId');
        this.terminationEmployeeList = terminatedEmpData;
        this.currentterminationEmployeeList = terminatedEmpData;
        this.terminatedUserId = terminatedEmpData.filter((elm: any) => elm.userId == this.loggedInUserId && elm.revolveStatus == false);
        this.listOffTerminatedEmployee = terminatedEmpData.map((elm: any) => elm.userId);
      }

    })
  }

  onEdittermination(item: any, type: any) {
    this.employeeTermintion(item, type);
  }
  updateTermination(item: any) {
    console.log(item);

    let formData

    this.confirmAction('Are you sure you want to revoke ?')
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          formData = {
            "terminationFormId": item.terminationFormId,
            "hrId": item?.hrId,
            "userId": item?.userId,
            "companyId": item?.companyId,
            "year": item.year,
            "fiscalYear": item.fiscalYear,
            "empName": item.empName,
            "empDepartment": item?.empDepartment,
            "empGrade": item.empGrade,
            "empBand": item?.empBand,
            "empDesignation": item?.empDesignation,
            "dateOfTermination": item?.dateOfTermination,
            "terminationReason": item?.terminationReason,
            "lastWorkingDay": item?.lastWorkingDay,
            "hodCode": item?.hodCode,
            "empCode": item?.empCode,
            "userOfficialEmail": item?.userOfficialEmail,
            "hrMail": item?.hrMail,
            "managerCode": item?.managerCode,
            "personalMailId": item?.personalMailId,
            "revolveStatus": true
          }
          this.httpService.callPostService(`${this.config.terminationform}`, formData).subscribe(
            (response: any) => {
              this.toastr.success(response.message);
              this.getterminationFormData();
            },
            (error: any) => {
              const errorMsg = this.updateEmployeeData?.terminationFormId ? " Failed to updated" : "Failed to Added";
              this.toastr.error(errorMsg);
            }
          );
        } else {

          this.getterminationFormData();
          console.log('User cancelled regret confirmation.');
          return
        }
      });




  }





  actions = [
    { label: 'Accept', status: 'APPROVED', class: 'accept' },
    { label: 'Reject', status: 'REJECTED', class: 'reject' }
  ];

  setApproval(item: any, status: string): void {
    item.approvalStatus = status;
    this.updatedData(item);
  }




  isAdminRole(role: string): boolean {
    return ['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(role);
  }

  isActionDisabled(item: any): boolean {
    return item.terminationFormId != null || item.withdrawalAccepted == true;
  }

  getRowStyle(item: any): { [key: string]: string } {
    return item.withdrawalAccepted ? { 'background-color': '#dbd8d8' } : {};
  }
  canShowManagerCommentSection(): boolean {
    return this.checkAuthority === 'MANAGER_AND_HR' || this.checkAuthority === 'HOD_AND_MANAGER_AND_HR';
  }

  canShowHodCommentSection(): boolean {
    return this.checkAuthority === 'HOD_AND_HR' || this.checkAuthority === 'HOD_AND_MANAGER_AND_HR';
  }

  // Readonly conditions
  isManagerCommentReadonly(item: any): boolean {
    return this.selectedTypeTabName !== 'teamResigntion' ||
      item.terminationFormId !== null ||
      item.withdrawalReason !== null ||

      item?.approvalStatus !== 'PENDING';
  }

  isHodCommentReadonly(item: any): boolean {
    return this.selectedTypeTabName !== 'deptResigntion' ||
      item.terminationFormId !== null ||
      item.withdrawalReason !== null ||

      item?.approvalStatus !== 'PENDING';
  }

  // Focus out handlers
  handleManagerFocusOut(item: any): void {
    if (item.approvalStatus != 'PENDING') {
      return;
    }
    if (this.selectedTypeTabName === 'teamResigntion' &&
      item.terminationFormId == null &&
      item.withdrawalReason == null) {
      this.updatedData(item);
    }
  }

  handleHodFocusOut(item: any): void {
    if (item.approvalStatus != 'PENDING') {
      return;
    }
    if (this.selectedTypeTabName === 'deptResigntion' &&
      item.terminationFormId == null) {
      this.updatedData(item);
    }
  }
  canShowSecretReason(): boolean {
    return this.selectedTypeTabName === 'myResigntion' ||
      ['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(this.loggedInUserRole);
  }

  isEditDisabled(item: any, allItems: any[]): boolean {
    const isOwnRow = item.userId === this.loggedInUserId;

    // Check if any entry for the same user is approved
    const hasApprovedEntry = allItems.some(
      entry => entry.userId === item.userId && entry.approvalStatus !== 'PENDING'
    );

    // Disable if not own row, or any entry is approved, or this row is not pending
    return !isOwnRow || item.approvalStatus !== 'PENDING' || hasApprovedEntry;
  }

  // Define arrays for easier checks
  allowedAuthorities = ['HOD_AND_HR', 'MANAGER_AND_HR', 'HOD_AND_MANAGER_AND_HR'];
  allowedTabNames = ['teamResigntion', 'deptResigntion'];
  excludedRoles = ['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'];

  // Create a getter or method to check the condition
  get showTd(): boolean {
    return this.allowedAuthorities.includes(this.checkAuthority) &&
      this.allowedTabNames.includes(this.selectedTypeTabName) &&
      !this.excludedRoles.includes(this.loggedInUserRole);
  }

}
